import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { FeatureToggleService } from '../../services/feature-toggle/feature-toggle.service';
import { Feature } from '../../model/features.enum';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const featureToggleService = inject(FeatureToggleService);
  if (featureToggleService.when(Feature.WebBackend)()) {
    const credentialReq = req.clone({
      withCredentials: true,
    });
    return next(credentialReq);
  }

  return next(req);
};
